import {
  AxiosResponse,
} from 'axios';
import {
  paths,
} from '../openapi.ts';
import {
  axiosClient,
} from '@/api/client';
// @ts-ignore: - potentially unused import
import {
  // @ts-ignore: - potentially unused import
  TApiPayload,
  // @ts-ignore: - potentially unused import
  interpolateUrl,
} from './_utils';
// @ts-ignore: - potentially unused import
import {
  QueryKey,
} from '@tanstack/vue-query';
import {
  getCompaniesRouteEndpoint,
  createCompanyRouteEndpoint,
  getCompanyRouteEndpoint,
  updateCompanyRouteEndpoint,
  deleteCompanyRouteEndpoint,
  getProjectsRouteEndpoint,
  createProjectRouteEndpoint,
  getProjectRouteEndpoint,
  updateProjectRouteEndpoint,
  deleteProjectRouteEndpoint,
  getCalculationRevisionRouteEndpoint,
  getAppGroupsEndpoint,
  getPriceCalculatorSettingsRouteEndpoint,
  setPriceCalculatorSettingsRouteEndpoint,
  getUsersPublicInfoRouteEndpoint,
} from './price-calculator.endpoints.ts';

export * from './price-calculator.endpoints.ts';

export type TGetCompaniesRouteResponse200 = paths['/price-calculator/companies']['get']['responses']['200']['content']['application/json'];
export type TGetCompaniesRouteResponse = TGetCompaniesRouteResponse200;
export const getCompaniesRouteQueryKey = (): QueryKey => ([...["price-calculator","companies"]]);
export function getCompaniesRoute(abortSignal?: AbortSignal): Promise<AxiosResponse<TGetCompaniesRouteResponse>> {
  return axiosClient.get(getCompaniesRouteEndpoint, { signal: abortSignal });
}

export type TCreateCompanyRouteBodyParams = paths['/price-calculator/companies']['post']['requestBody']['content']['application/json'];
export type TCreateCompanyRoutePayload = TApiPayload<undefined, undefined, TCreateCompanyRouteBodyParams>;
export type TCreateCompanyRouteResponse200 = paths['/price-calculator/companies']['post']['responses']['200']['content']['application/json'];
export type TCreateCompanyRouteResponse = TCreateCompanyRouteResponse200;
export const createCompanyRouteQueryKey = (): QueryKey => ([...["price-calculator","companies"]]);
export function createCompanyRoute(payload: TCreateCompanyRoutePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TCreateCompanyRouteResponse>> {
  return axiosClient.post(createCompanyRouteEndpoint, payload.bodyParams, { signal: abortSignal });
}

export type TGetCompanyRoutePath = paths['/price-calculator/companies/{companyId}']['get']['parameters']['path'];
export type TGetCompanyRoutePayload = TApiPayload<TGetCompanyRoutePath, undefined, undefined>;
export type TGetCompanyRouteResponse200 = paths['/price-calculator/companies/{companyId}']['get']['responses']['200']['content']['application/json'];
export type TGetCompanyRouteResponse = TGetCompanyRouteResponse200;
export const getCompanyRouteQueryKey = (companyId: QueryKey[number]): QueryKey => ([...["price-calculator","companies"], companyId]);
export function getCompanyRoute(payload: TGetCompanyRoutePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TGetCompanyRouteResponse>> {
  return axiosClient.get(interpolateUrl(getCompanyRouteEndpoint, payload.path), { signal: abortSignal });
}

export type TUpdateCompanyRoutePath = paths['/price-calculator/companies/{companyId}']['put']['parameters']['path'];
export type TUpdateCompanyRouteBodyParams = paths['/price-calculator/companies/{companyId}']['put']['requestBody']['content']['application/json'];
export type TUpdateCompanyRoutePayload = TApiPayload<TUpdateCompanyRoutePath, undefined, TUpdateCompanyRouteBodyParams>;
export type TUpdateCompanyRouteResponse200 = paths['/price-calculator/companies/{companyId}']['put']['responses']['200']['content']['application/json'];
export type TUpdateCompanyRouteResponse = TUpdateCompanyRouteResponse200;
export const updateCompanyRouteQueryKey = (companyId: QueryKey[number]): QueryKey => ([...["price-calculator","companies"], companyId]);
export function updateCompanyRoute(payload: TUpdateCompanyRoutePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TUpdateCompanyRouteResponse>> {
  return axiosClient.put(interpolateUrl(updateCompanyRouteEndpoint, payload.path), payload.bodyParams, { signal: abortSignal });
}

export type TDeleteCompanyRoutePath = paths['/price-calculator/companies/{companyId}']['delete']['parameters']['path'];
export type TDeleteCompanyRoutePayload = TApiPayload<TDeleteCompanyRoutePath, undefined, undefined>;
export type TDeleteCompanyRouteResponse200 = paths['/price-calculator/companies/{companyId}']['delete']['responses']['200']['content']['application/json'];
export type TDeleteCompanyRouteResponse = TDeleteCompanyRouteResponse200;
export const deleteCompanyRouteQueryKey = (companyId: QueryKey[number]): QueryKey => ([...["price-calculator","companies"], companyId]);
export function deleteCompanyRoute(payload: TDeleteCompanyRoutePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TDeleteCompanyRouteResponse>> {
  return axiosClient.delete(interpolateUrl(deleteCompanyRouteEndpoint, payload.path), { signal: abortSignal });
}

export type TGetProjectsRouteResponse200 = paths['/price-calculator/projects']['get']['responses']['200']['content']['application/json'];
export type TGetProjectsRouteResponse = TGetProjectsRouteResponse200;
export const getProjectsRouteQueryKey = (): QueryKey => ([...["price-calculator","projects"]]);
export function getProjectsRoute(abortSignal?: AbortSignal): Promise<AxiosResponse<TGetProjectsRouteResponse>> {
  return axiosClient.get(getProjectsRouteEndpoint, { signal: abortSignal });
}

export type TCreateProjectRouteBodyParams = paths['/price-calculator/projects']['post']['requestBody']['content']['application/json'];
export type TCreateProjectRoutePayload = TApiPayload<undefined, undefined, TCreateProjectRouteBodyParams>;
export type TCreateProjectRouteResponse200 = paths['/price-calculator/projects']['post']['responses']['200']['content']['application/json'];
export type TCreateProjectRouteResponse = TCreateProjectRouteResponse200;
export const createProjectRouteQueryKey = (): QueryKey => ([...["price-calculator","projects"]]);
export function createProjectRoute(payload: TCreateProjectRoutePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TCreateProjectRouteResponse>> {
  return axiosClient.post(createProjectRouteEndpoint, payload.bodyParams, { signal: abortSignal });
}

export type TGetProjectRoutePath = paths['/price-calculator/projects/{projectId}']['get']['parameters']['path'];
export type TGetProjectRoutePayload = TApiPayload<TGetProjectRoutePath, undefined, undefined>;
export type TGetProjectRouteResponse200 = paths['/price-calculator/projects/{projectId}']['get']['responses']['200']['content']['application/json'];
export type TGetProjectRouteResponse = TGetProjectRouteResponse200;
export const getProjectRouteQueryKey = (projectId: QueryKey[number]): QueryKey => ([...["price-calculator","projects"], projectId]);
export function getProjectRoute(payload: TGetProjectRoutePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TGetProjectRouteResponse>> {
  return axiosClient.get(interpolateUrl(getProjectRouteEndpoint, payload.path), { signal: abortSignal });
}

export type TUpdateProjectRoutePath = paths['/price-calculator/projects/{projectId}']['put']['parameters']['path'];
export type TUpdateProjectRouteBodyParams = paths['/price-calculator/projects/{projectId}']['put']['requestBody']['content']['application/json'];
export type TUpdateProjectRoutePayload = TApiPayload<TUpdateProjectRoutePath, undefined, TUpdateProjectRouteBodyParams>;
export type TUpdateProjectRouteResponse200 = paths['/price-calculator/projects/{projectId}']['put']['responses']['200']['content']['application/json'];
export type TUpdateProjectRouteResponse = TUpdateProjectRouteResponse200;
export const updateProjectRouteQueryKey = (projectId: QueryKey[number]): QueryKey => ([...["price-calculator","projects"], projectId]);
export function updateProjectRoute(payload: TUpdateProjectRoutePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TUpdateProjectRouteResponse>> {
  return axiosClient.put(interpolateUrl(updateProjectRouteEndpoint, payload.path), payload.bodyParams, { signal: abortSignal });
}

export type TDeleteProjectRoutePath = paths['/price-calculator/projects/{projectId}']['delete']['parameters']['path'];
export type TDeleteProjectRoutePayload = TApiPayload<TDeleteProjectRoutePath, undefined, undefined>;
export type TDeleteProjectRouteResponse200 = paths['/price-calculator/projects/{projectId}']['delete']['responses']['200']['content']['application/json'];
export type TDeleteProjectRouteResponse = TDeleteProjectRouteResponse200;
export const deleteProjectRouteQueryKey = (projectId: QueryKey[number]): QueryKey => ([...["price-calculator","projects"], projectId]);
export function deleteProjectRoute(payload: TDeleteProjectRoutePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TDeleteProjectRouteResponse>> {
  return axiosClient.delete(interpolateUrl(deleteProjectRouteEndpoint, payload.path), { signal: abortSignal });
}

export type TGetCalculationRevisionRouteQuery = paths['/price-calculator/calculations/{projectId}']['get']['parameters']['query'];
export type TGetCalculationRevisionRoutePath = paths['/price-calculator/calculations/{projectId}']['get']['parameters']['path'];
export type TGetCalculationRevisionRoutePayload = TApiPayload<TGetCalculationRevisionRoutePath, TGetCalculationRevisionRouteQuery, undefined>;
export type TGetCalculationRevisionRouteResponse200 = paths['/price-calculator/calculations/{projectId}']['get']['responses']['200']['content']['application/json'];
export type TGetCalculationRevisionRouteResponse = TGetCalculationRevisionRouteResponse200;
export const getCalculationRevisionRouteQueryKey = (projectId: QueryKey[number], query?: TGetCalculationRevisionRouteQuery): QueryKey => ([...["price-calculator","calculations"], projectId, ...(query ? [query] : [])]);
export function getCalculationRevisionRoute(payload: TGetCalculationRevisionRoutePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TGetCalculationRevisionRouteResponse>> {
  return axiosClient.get(interpolateUrl(getCalculationRevisionRouteEndpoint, payload.path), { signal: abortSignal, params: payload.query });
}

export type TGetAppGroupsResponse200 = paths['/price-calculator/app/groups']['get']['responses']['200']['content']['application/json'];
export type TGetAppGroupsResponse = TGetAppGroupsResponse200;
export const getAppGroupsQueryKey = (): QueryKey => ([...["price-calculator","app","groups"]]);
export function getAppGroups(abortSignal?: AbortSignal): Promise<AxiosResponse<TGetAppGroupsResponse>> {
  return axiosClient.get(getAppGroupsEndpoint, { signal: abortSignal });
}

export type TGetPriceCalculatorSettingsRouteQuery = paths['/price-calculator/settings']['get']['parameters']['query'];
export type TGetPriceCalculatorSettingsRoutePayload = TApiPayload<undefined, TGetPriceCalculatorSettingsRouteQuery, undefined>;
export type TGetPriceCalculatorSettingsRouteResponse200 = paths['/price-calculator/settings']['get']['responses']['200']['content']['application/json'];
export type TGetPriceCalculatorSettingsRouteResponse = TGetPriceCalculatorSettingsRouteResponse200;
export const getPriceCalculatorSettingsRouteQueryKey = (query?: TGetPriceCalculatorSettingsRouteQuery): QueryKey => ([...["price-calculator","settings"], ...(query ? [query] : [])]);
export function getPriceCalculatorSettingsRoute(payload: TGetPriceCalculatorSettingsRoutePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TGetPriceCalculatorSettingsRouteResponse>> {
  return axiosClient.get(getPriceCalculatorSettingsRouteEndpoint, { signal: abortSignal, params: payload.query });
}

export type TSetPriceCalculatorSettingsRouteBodyParams = paths['/price-calculator/settings']['put']['requestBody']['content']['application/json'];
export type TSetPriceCalculatorSettingsRoutePayload = TApiPayload<undefined, undefined, TSetPriceCalculatorSettingsRouteBodyParams>;
export type TSetPriceCalculatorSettingsRouteResponse200 = paths['/price-calculator/settings']['put']['responses']['200']['content']['application/json'];
export type TSetPriceCalculatorSettingsRouteResponse = TSetPriceCalculatorSettingsRouteResponse200;
export const setPriceCalculatorSettingsRouteQueryKey = (): QueryKey => ([...["price-calculator","settings"]]);
export function setPriceCalculatorSettingsRoute(payload: TSetPriceCalculatorSettingsRoutePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TSetPriceCalculatorSettingsRouteResponse>> {
  return axiosClient.put(setPriceCalculatorSettingsRouteEndpoint, payload.bodyParams, { signal: abortSignal });
}

export type TGetUsersPublicInfoRouteQuery = paths['/price-calculator/users/public-info']['get']['parameters']['query'];
export type TGetUsersPublicInfoRoutePayload = TApiPayload<undefined, TGetUsersPublicInfoRouteQuery, undefined>;
export type TGetUsersPublicInfoRouteResponse200 = paths['/price-calculator/users/public-info']['get']['responses']['200']['content']['application/json'];
export type TGetUsersPublicInfoRouteResponse = TGetUsersPublicInfoRouteResponse200;
export const getUsersPublicInfoRouteQueryKey = (query?: TGetUsersPublicInfoRouteQuery): QueryKey => ([...["price-calculator","users","public-info"], ...(query ? [query] : [])]);
export function getUsersPublicInfoRoute(payload: TGetUsersPublicInfoRoutePayload, abortSignal?: AbortSignal): Promise<AxiosResponse<TGetUsersPublicInfoRouteResponse>> {
  return axiosClient.get(getUsersPublicInfoRouteEndpoint, { signal: abortSignal, params: payload.query });
}

